module.exports = __webpack_public_path__ + "static/media/yellowStarIcon.1bb93f20.svg";